import * as Sentry from '@sentry/core';

import type { ReportExceptionOptions } from './errors';
import { getSentryCurrentScope } from './sentry';

/**
 * Manually report an error to Sentry.
 * In the browser, it should most of the time not be necessary to use this function as
 * unhandled exceptions are automatically reported to Sentry.
 * But it's needed when the error is being swallow by the UI.
 */
export function reportException(error: Error, options: ReportExceptionOptions = {}): string {
    if (options.attachments?.length) {
        options.attachments.forEach((attachment) => {
            getSentryCurrentScope().addAttachment({
                filename: attachment.name,
                data: attachment.body,
                contentType: attachment.type,
            });
        });
    }

    const eventId = Sentry.captureException(error, {
        tags: options.tags || {},
        extra: options.extra,
        level: options.level,
    });

    getSentryCurrentScope().clearAttachments();

    return eventId;
}
